import type {ZodType} from "zod";
import {z as zod} from "zod";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type WorkspaceAccessMatrix = Record<Uuid, boolean>;

export const workspaceAccessMatrixValidator: ZodType<WorkspaceAccessMatrix> = zod.record(
    uuidZodValidator,
    zod.boolean(),
);
